import { CoachingExplanation }
  from "@/components/coaching/CoachingExplanation";
import {
  formatDate,
  formatDayStatus,
} from "@/lib/coachingFormatters";
import { ScheduledWorkoutCard } from "@/components/coaching/ScheduledWorkoutCard";
import { enrichCoachSession } from "@/lib/activePlanDisplay";

const dayStatusToken = {
  TRAINING_DAY: "bg-brand-primary/15 border-brand-primary text-brand-primary",
  RECOVERY_DAY: "bg-analytics-blue/15 border-analytics-blue text-analytics-blue",
  REST_DAY: "bg-[var(--surface-secondary)] border-[var(--border-primary)] text-dark-text-secondary",
  EVENT_DAY: "bg-analytics-purple/15 border-analytics-purple text-analytics-purple",
  UNSCHEDULED_DAY: "bg-[var(--surface-secondary)] border-[var(--border-primary)] text-dark-text-secondary",
  PLAN_SUSPENDED: "bg-analytics-red/15 border-analytics-red text-analytics-red",
  CONTEXT_INCOMPLETE: "bg-[var(--surface-secondary)] border-[var(--border-primary)] text-dark-text-muted",
};

export const TodayCoachingCard = ({ today, timezone, explanation,
                                                    trainingSuppressed, activePlan }) => {
  const status = today?.day_status || "CONTEXT_INCOMPLETE";
  const sessions = Array.isArray(today?.scheduled_sessions)
    ? today.scheduled_sessions : [];
  const showSummary = !trainingSuppressed;

  return (
    <section
      aria-labelledby="coaching-today-heading"
      data-testid="coaching-today-card"
      className="app-card p-5 sm:p-6"
    >
      <div className="flex items-baseline justify-between gap-4 flex-wrap">
        <div>
          <p className="card-label">{formatDate(today?.date, timezone)}</p>
          <h2 id="coaching-today-heading" className="section-title mt-0.5">
            Today
          </h2>
        </div>
        <span
          className={`app-badge text-[10px] uppercase tracking-widest ${dayStatusToken[status] || dayStatusToken.CONTEXT_INCOMPLETE}`}
          data-testid="today-day-status"
        >
          {formatDayStatus(status)}
        </span>
      </div>

      {showSummary && sessions.length > 1 && (
        <p className="meta-text mt-3" data-testid="today-double-session-note">
          {sessions.length} sessions scheduled today
        </p>
      )}

      {showSummary && sessions.length > 0 ? (
        <ul className="mt-4 space-y-3" data-testid="today-sessions">
          {sessions.map((session) => (
            <li key={session.session_id}>
              <ScheduledWorkoutCard
                session={enrichCoachSession(session, activePlan)}
                timezone={timezone}
                testIdPrefix="today-workout"
                defaultExpanded={sessions.length === 1}
              />
            </li>
          ))}
        </ul>
      ) : (
        showSummary && (
          <p className="mt-4 text-dark-text-secondary text-sm" data-testid="today-no-session">
            No scheduled session for today.
          </p>
        )
      )}

      {explanation && (
        <div className="mt-4 pt-4 border-t border-[var(--border-primary)]">
          <CoachingExplanation
            explanation={explanation}
            showMeta={false}
            testId="today-explanation"
          />
        </div>
      )}
    </section>
  );
};
